import { render, staticRenderFns } from "./ButtonImageCollection.vue?vue&type=template&id=7f0b1d5c&scoped=true&"
import script from "./ButtonImageCollection.vue?vue&type=script&lang=js&"
export * from "./ButtonImageCollection.vue?vue&type=script&lang=js&"
import style0 from "./ButtonImageCollection.vue?vue&type=style&index=0&id=7f0b1d5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0b1d5c",
  null
  
)

export default component.exports